export const replace = (text, subs) => {
    const params = text.match(/${(.*?)}/g) || [];
    return params.reduce((result, param) => {
        return result.replace(param, subs[param.slice(2, -1)]);
    }, text);
};
export const matches = (a, b) => {
    const keys = Object.keys(a);
    for (const key of keys) {
        if (!Object.prototype.hasOwnProperty.call(b, key) || a[key] !== b[key]) {
            return false;
        }
    }
    return true;
};
export const validateImei = (s) => {
    const exp = /^[0-9]{15}$/;
    if (!exp.test(s)) {
        return false;
    }
    let sum = 0;
    let mul = 2;
    const l = 14;
    for (let i = 0; i < l; i++) {
        const digit = s.substring(l - i - 1, l - i);
        const tp = parseInt(digit, 10) * mul;
        if (tp >= 10) {
            sum += (tp % 10) + 1;
        }
        else {
            sum += tp;
        }
        if (mul === 1) {
            mul++;
        }
        else {
            mul--;
        }
    }
    const chk = (10 - (sum % 10)) % 10;
    return chk === parseInt(s.substring(14, 15), 10);
};
